/** Ceiling on how many pages a design is ever probed for - matches the server's own render limits. */
export const DESIGN_PAGE_PROBE_LIMIT = 20

/** Counts a design's rendered pages by probing 1..`limit` for the first missing one; the server stores no page count. */
export async function probeDesignPageCount(
  pageExists: (page: number) => Promise<boolean>,
  limit: number = DESIGN_PAGE_PROBE_LIMIT,
): Promise<number> {
  let count = 0
  for (let page = 1; page <= limit; page++) {
    if (!(await pageExists(page))) break
    count = page
  }
  return count
}
